module.exports = __webpack_public_path__ + "img/logo.622ed997.svg";